import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import DropdownTextEditorTool from '../DropdownTextEditorTool';
import DropdownTextEditorToolToggle from '../DropdownTextEditorToolToggle';
import DropdownTextEditorToolEditableValue from '../DropdownTextEditorToolEditableValue';
import getDropdownOptionText from '../../../../../utils/getDropdownOptionText';

import styles from './EditableDropdownTextEditorTool.scss';

const EditableDropdownTextEditorTool = ({
  value,
  onChange,
  options,
  className,
  onToggle,
  tooltip,
  maxValue,
  minValue,
}) => (
  <DropdownTextEditorTool
    className={cx(className, styles.dropdown)}
    onChange={onChange}
    options={options}
    value={value}
    onToggle={onToggle}
    renderToggle={({ isOpened, toggle }) => (
      <DropdownTextEditorToolToggle
        onToggle={toggle}
        tooltip={tooltip}
        isOpened={isOpened}
        className={className}
      >
        <DropdownTextEditorToolEditableValue
          value={getDropdownOptionText(options, value)}
          isOpened={isOpened}
          maxValue={maxValue}
          minValue={minValue}
          onChange={value => onChange({ value })}
          onToggle={toggle}
        />
      </DropdownTextEditorToolToggle>
    )}
  />
);

EditableDropdownTextEditorTool.propTypes = {
  value: PropTypes.number,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  onToggle: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
    }),
  ),
};

export default EditableDropdownTextEditorTool;
